import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

function SettingsPage() {
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <div className="flex flex-col lg:flex-row gap-8 max-w-7xl mx-auto w-full">
      
      {/* Menu Interno de Configurações */}
      <aside className="lg:w-64 flex-shrink-0">
        <h2 className="text-2xl font-bold font-manrope text-slate-900 mb-6">Configurações</h2>
        
        <nav className="flex flex-col space-y-1">
          <NavLink 
            to="/app/settings/profile" 
            className={({isActive}) => `flex items-center space-x-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors ${isActive ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            <span className="material-symbols-outlined text-[20px]">person</span>
            <span>Meu Perfil</span>
          </NavLink>
          
          <NavLink 
            to="/app/settings/categories" 
            className={({isActive}) => `flex items-center space-x-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors ${isActive ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            <span className="material-symbols-outlined text-[20px]">label</span>
            <span>Categorias</span>
          </NavLink>
          
          {user?.role === 'admin' && (
            <NavLink 
              to="/app/settings/admin" 
              className={({isActive}) => `flex items-center space-x-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors ${isActive ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`}
            >
              <span className="material-symbols-outlined text-[20px]">admin_panel_settings</span>
              <span>Administração</span>
            </NavLink>
          )}
        </nav>

        <div className="mt-10 pt-6 border-t border-slate-200">
          <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-4 px-4">Aparência</h3>
          <div className="px-4">
             <ThemeToggle />
          </div>
        </div>
      </aside>

      {/* Contentor principal onde as sub-páginas vão aparecer */}
      <main className="flex-1 bg-white rounded-2xl border border-slate-200 shadow-sm p-6 lg:p-10 min-h-[500px]">
        <Outlet />
      </main>
      
    </div>
  );
}

export default SettingsPage;